import type { ProductQuoteApp } from 'apps/productQuote/app';
import type { RouterStore } from 'core/routing/store';
import { graphqlIdToDBId } from 'utils/dgraphId';

interface QuoteNavigateObj {
  customerSlug?: string;
  rfqids?: string[];
  pqids?: string[];
}

export function ShipmentQuoteNavigate(
  routerStore: RouterStore,
  { rfqids, pqids, customerSlug }: QuoteNavigateObj,
) {
  const existingRfqids = routerStore.params.get('rfqids')?.slice() || [];
  const existingPqids = routerStore.params.get('pqids')?.slice() || [];
  routerStore.navigate('new-quote', {
    customerSlug: customerSlug || routerStore.params.get('customerSlug'),
    rfqids: rfqids || existingRfqids,
    pqids: pqids || existingPqids,
  });
}

export function ObjToDBId(productQuote: ProductQuoteApp) {
  if (!productQuote?.id) return null;
  return graphqlIdToDBId(productQuote.id);
}

interface DgraphNode {
  dgraphId: string;
}

export function AddId(
  routerStore: RouterStore,
  paramName: string, // e.g. 'rfqids' or 'pqids'
  node: DgraphNode, // e.g. ProductQuoteApp or RFQApp
) {
  const tmpIds = routerStore.params.get(paramName) || [];
  return tmpIds.concat(node.dgraphId);
}

export function RemoveId(
  routerStore: RouterStore,
  paramName: string, // e.g. 'rfqids' or 'pqids'
  node: DgraphNode, // e.g. ProductQuoteApp or RFQApp
) {
  const currentParams = routerStore.params.get(paramName).slice();
  if (!currentParams || currentParams.length === 0) return [];
  const lastIndex = currentParams.lastIndexOf(node.dgraphId);
  if (lastIndex === -1) return currentParams;
  currentParams.splice(lastIndex, 1);
  return currentParams;
}
